import { createAction } from '@reduxjs/toolkit';
import { lookupSale } from 'services/billingPortalService';
import billingPortalServiceErrors from 'services/billingPortalService/errors';

export const saleCleanSuccess = createAction('SALES_SALE_CLEAN');
export const saleSetSuccess = createAction('SALES_SALE_SET_SUCCESS');
export const saleLookupInit = createAction('SALES_SALE_LOOKUP_INIT');
export const saleLookupSuccess = createAction('SALES_SALE_LOOKUP_SUCCESS');
export const saleLookupFail = createAction('SALES_SALE_LOOKUP_FAIL');

export const saleClean = () => (dispatch) => dispatch(saleCleanSuccess());

export const saleSet = (sale) => (dispatch) => dispatch(saleSetSuccess(sale));

const getErrorMessage = (errorMessage) => {
  switch (errorMessage) {
    case billingPortalServiceErrors.MISSING_NUMBER_OR_TOTAL:
      return 'El número y total de la compra son requeridos.';
    case billingPortalServiceErrors.NUMBER_IS_NAN:
      return 'El total de la compra debe ser un número.';
    case billingPortalServiceErrors.INVOICE_ALREADY_GENERATED:
      return 'La factura de la compra ya fue generada.';
    case billingPortalServiceErrors.INVOICE_ALREADY_REQUESTED:
      return 'La factura de la compra ya fue solicitada.';
    case billingPortalServiceErrors.INVOICE_TOO_OLD:
      return 'La compra es muy antigua y su factura ya no está disponible.';
    case billingPortalServiceErrors.NOT_FOUND:
      return 'No se encontró la compra especificada.';
    default:
      if (errorMessage) {
        return errorMessage;
      }
      return 'Ocurrió un error inesperado, por favor inténtelo más tarde.';
  }
};

export const saleLookup = (sale) => async (dispatch) => {
  dispatch(saleLookupInit());
  try {
    const response = await lookupSale(sale);
    if (response.statusCode === 200) {
      return dispatch(
        saleLookupSuccess({
          token: response.token,
          sale: response.sale,
          customer: response.customer,
        })
      );
    }
    return dispatch(
      saleLookupFail({
        error: {
          statusCode: response.statusCode,
          message: getErrorMessage(response.message),
        },
      })
    );
  } catch (error) {
    return dispatch(
      saleLookupFail({
        error: {
          statusCode: -1,
          message: error.message,
        },
      })
    );
  }
};
